<template>
  <section class="outer-container outer-container--light-gray">
    <section class="folder-section">
      <h2 class="folder-section__heading">{{ documentView.name }}</h2>
      <transition name="fade">
        <section>
          <div class="loader" v-if="isLoading">
            <img src="../assets/images/loading-spinner.svg" alt="Loading..." />
          </div>
          <transition name="fade">
            <section>
              <section id="blueimp-gallery-container">
                <vue-gallery
                  v-bind:images="images"
                  v-bind:index="index"
                  v-bind:options="galleryOptions"
                  v-on:close="index = null"
                ></vue-gallery>
              </section>
              <div class="underlay" v-if="typeof index === 'number'"></div>
              <ux-folder-content-container
                v-if="size === 'lg'"
                class="folder"
                :class="`size-${size}`"
                v-bind:folder="folder"
                v-bind:size="size"
                v-for="folder in documentView.folders"
                v-bind:key="folder.id"
              ></ux-folder-content-container>
              <ux-small-form-factor-folder-content-container
                v-if="size === 'md'"
                v-bind:folder-structure="documentView"
              ></ux-small-form-factor-folder-content-container>
            </section>
          </transition>
        </section>
      </transition>
    </section>
  </section>
</template>

<script>
import Vue from "vue";
Vue.use(require("vue-moment"));

export default {
  name: "documentbrowser",
  data() {
    var dataInst = this;
    return {
      documentView: {},
      pagination: {},
      isLoading: false,
      size: window.innerWidth <= 767 ? "md" : "lg",
      images: [],
      index: null,
      galleryOptions: {
        continuous: false,
        onslide(index) {
          const imagesCount = dataInst.images.length;
          const { description, href } = dataInst.images[index],
            node = this.container.find(".description"),
            span = document.createElement("span"),
            a = document.createElement("a"),
            indicator = document.createElement("sub");

          node.empty();
          if (description) {
            span.appendChild(document.createTextNode(description));
          }

          a.appendChild(document.createTextNode("Download"));
          a.setAttribute("target", "_blank");
          a.setAttribute("href", href + "&download=true");

          indicator.appendChild(
            document.createTextNode(`${index + 1} of ${imagesCount}`)
          );
          indicator.classList.add("indicator");

          node[0].appendChild(indicator);
          node[0].appendChild(span);
          node[0].appendChild(a);
        }
      }
    };
  },
  methods: {
    load(id = 0, group_id = 0, pageSize = 10, page = 1, root, cb, err) {
      if (id === 0) {
        return;
      }

      if (!root) {
        this.isLoading = true;
      }

      /*
       * If you provide the parameter for page and pageSize you will get the appropriate results back.
       * In this case you will get page 1 with size of 10 (default is 20)
       */
      this.$store
        .dispatch("documentview", { id, group_id, page, pageSize })
        .then(
          response => {
            // Data
            // root object is a tree that would be augmented, e.g. populating files for a folder
            // if it is not provided, it means this is the initial tree structure
            if (root) {
              root.folders = response.data.data.folders;
              root.files = root.files
                ? root.files.concat(response.data.data.files)
                : response.data.data.files;
              root.pagination = response.data.pagination;
              if (cb) {
                cb();
              }
            } else {
              this.documentView = response.data.data;
              this.pagination = response.data.pagination;
              this.isLoading = false;
            }
          },
          error => {
            this.isLoading = false;
            if (err) {
              err();
            }
            // Log the error
            console.error(error);
          }
        );
    },
    setSize() {
      this.size = window.innerWidth <= 767 ? "md" : "lg";
    },
    passImagesAndIndex(images, index) {
      this.index = index;
      this.images = images;
    }
  },
  created() {
    this.$root.$on("load-data", this.load);
    this.$root.$on("pass-images-and-index", this.passImagesAndIndex);
    window.addEventListener("resize", this.setSize, false);
  },
  mounted() {
    this.isLoading = true;
    this.load(this.$route.params.id, this.$root.config_.scopeGroupId);
  },
  beforeDestroy() {
    this.$root.$off("load-data", this.load);
    this.$root.$off("pass-images-and-index", this.passImagesAndIndex);
  },
  destroyed() {
    window.removeEventListener("resize", this.setSize, false);
  }
};
</script>
